import { render, staticRenderFns } from "./SfHeroItem.vue?vue&type=template&id=181fc598&"
import script from "./SfHeroItem.vue?vue&type=script&lang=js&"
export * from "./SfHeroItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports